/**
 * Created by Florin David on 07/10/2016.
 */
import { combineReducers } from 'redux'

import version from './version'
import intl from './intl'
import error from './error'
import update from './update'
import offline from './offline'
import auth from './auth'
import search from './search'
import settings from './settings'
import Action, { RESET_STATE } from 'constants/action-types'

const appReducer = combineReducers({
  version,
  intl,
  error,
  update,
  offline,
  auth,
  search,
  settings,
})

export type State = ReturnType<typeof appReducer>

export default (
  state: ReturnType<typeof appReducer>,
  action: Action,
): ReturnType<typeof appReducer> => {
  if (action.type === RESET_STATE) {
    state = action.payload as ReturnType<typeof appReducer>
  }

  return appReducer(state, action)
}
